<div class="center-stage">
  <h1>Session Expired</h1>
  <p class="lead">Your session has expired. Log on again to re-enter the Station.</p>
</div>
